import {
  EmojiHappyIcon,
  PhotographIcon,
  XIcon,
} from '@heroicons/react/outline';

import { useState, useRef } from 'react';
import { db, storage } from '../firebase';

import { useRecoilState } from 'recoil';
import { userState } from '../atom/userAtom';
import { signOut, getAuth } from 'firebase/auth';

import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import { getDownloadURL, ref, uploadString } from 'firebase/storage';

export default function Input() {
  const filePickerRef = useRef(null);
  const auth = getAuth();

  const [currentUser, setCurrentUser] = useRecoilState(userState);
  const [input, setInput] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setloading] = useState(false);
 
  const sendPost = async () => {
    if (loading) return;
    setloading(true);

    const docRef = await addDoc(collection(db, "posts"), {
      id: currentUser.uid,
      text: input,
      useImg: currentUser.userImg,
      timestamp: serverTimestamp(),
      name: currentUser.name,
      username: currentUser.username,
    });

    const imageRef = ref(storage, `posts/${docRef.id}/image`);

    if (selectedFile) {
      await uploadString(imageRef, selectedFile, 'data_url').then(async () => {
        const downloadURL = await getDownloadURL(imageRef);
        await updateDoc(doc(db, 'posts', docRef.id), {
          image: downloadURL,
        });
      });
    }

    setInput('');
    setSelectedFile(null);
    setloading(false);
  }
  const addImageToPost = (e) => {
    const reader = new FileReader();
    if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
    }

    reader.onloadend = (readerEvent) => {
      setSelectedFile(readerEvent.target.result);
    };
  };

  function onSignOut() {
    signOut(auth);
    setCurrentUser(null);
  }

  return (
    <>
      {currentUser && (
        <div className="flex  border-b border-gray-400 p-3 space-x-3  border- mb-2   ">
          <img
            onClick={onSignOut}
            src={currentUser?.userImg}
            alt="user-img"
            className="h-11 w-11 rounded-full cursor-pointer hover:brightness-95"
          />
          <div className="w-full divide-y divide-gray-400">
            <div className="">
              <textarea
                className="bg-gray-900 w-full border-none focus:ring-0 text-lg placeholder-gray-300 tracking-wide min-h-[50px] text-gray-300"
                rows="2"
                placeholder="Whats on your mind?"
                value={input}
                onChange={(e) => setInput(e.target.value)}
              ></textarea>

              {selectedFile && (
                <div className=" relative border border-gray-300 shadow-2xl hadow-blue-500/50   ">
                  <XIcon
                    className="h-7  text-red-600 absolute cursor-pointer border m-1 animate-bounce  bg-white  shadow-white hover:     p-1 rounded-full "
                    onClick={() => setSelectedFile(null)}
                  />
                  <img
                    src={selectedFile}
                    className={`${loading && ' animate-pulse  '}`}
                  />
                </div>
              )}
            </div>
            <div className="flex items-center justify-between pt-2.5">
              {!loading && (
                <>
                  <div className="flex">
                    <div onClick={() => filePickerRef.current.click()}>
                      <PhotographIcon className="h-10 w-10 hoverEffect p-2 text-sky-500 hover:bg-sky-100" />

                      <input
                        type="file"
                        hidden
                        ref={filePickerRef}
                        onChange={addImageToPost}
                      />
                    </div>

                    <EmojiHappyIcon className="h-10 w-10 hoverEffect p-2 text-sky-500 hover:bg-sky-100" />
                  </div>
                  <button
                    onClick={sendPost}
                    disabled={!input.trim()}
                    className=" font-bold text-lg bg-sky-500 text-white px-4 py-1.5 rounded-full shadow-md hover:brightness-95 disabled:opacity-50    transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110 hover:bg-blue-600 duration-300 ..."
                  >
                    Post
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}